module.exports = __webpack_public_path__ + "static/media/less.cca4b658.svg";